import type maplibregl from "maplibre-gl";
import type { ExpressionStyleDefinition } from "@designboticteam/map";
import { buildStateExpression } from "../expressionBuilders/buildStateExpression";

function createStyleExpressionOutlineLayer({
	sourceId,
	sourceLayerId,
	attribute,
	idle,
	hover,
	isVisible,
}: {
	sourceId: string;
	sourceLayerId: string;
	attribute: string;
	idle: ExpressionStyleDefinition;
	hover: ExpressionStyleDefinition;
	isVisible: boolean;
}): maplibregl.AddLayerObject {
	return {
		id: `${sourceId}__outline`,
		source: sourceId,
		"source-layer": sourceLayerId,
		type: "line",
		paint: {
			"line-color": buildStateExpression({
				expression: {
					attribute,
					idle: {
						cases: Object.entries(idle.cases).flatMap(([caseName, styleDefinition]) => {
							return styleDefinition.outline === undefined ? [] : [[caseName, styleDefinition.outline.color]];
						}),
						fallback: idle.fallback?.outline?.color ?? "#000000",
					},
					hover: {
						cases: Object.entries(hover.cases).flatMap(([caseName, styleDefinition]) => {
							return styleDefinition.outline === undefined ? [] : [[caseName, styleDefinition.outline.color]];
						}),
						fallback: hover.fallback?.outline?.color ?? "#000000",
					},
				},
			}),
			"line-opacity": buildStateExpression({
				globalStateModifierKey: `opacity__${sourceId}`,
				expression: {
					attribute,
					idle: {
						cases: Object.entries(idle.cases).flatMap(([caseName, styleDefinition]) => {
							return styleDefinition.outline === undefined ? [] : [[caseName, styleDefinition.outline.opacity ?? 1]];
						}),
						fallback: idle.fallback?.outline?.opacity ?? 0,
					},
					hover: {
						cases: Object.entries(hover.cases).flatMap(([caseName, styleDefinition]) => {
							return styleDefinition.outline === undefined ? [] : [[caseName, styleDefinition.outline.opacity ?? 1]];
						}),
						fallback: hover.fallback?.outline?.opacity ?? 0,
					},
				},
			}),
			"line-width": buildStateExpression({
				expression: {
					attribute,
					idle: {
						cases: Object.entries(idle.cases).flatMap(([caseName, styleDefinition]) => {
							return styleDefinition.outline === undefined ? [] : [[caseName, styleDefinition.outline.width ?? 1]];
						}),
						fallback: idle.fallback?.outline?.width ?? 0,
					},
					hover: {
						cases: Object.entries(hover.cases).flatMap(([caseName, styleDefinition]) => {
							return styleDefinition.outline === undefined ? [] : [[caseName, styleDefinition.outline.width ?? 1]];
						}),
						fallback: hover.fallback?.outline?.width ?? 0,
					},
				},
			}),
		},
		layout: { visibility: isVisible ? "visible" : "none" },
	};
}

export { createStyleExpressionOutlineLayer };
